// TODO: I see a lot of pieces common from payment status screen and same issues. Please fix both of them and use common components.
import { Box, ColorOptions } from '@jfs/ui-new'
import { useInterval } from '@jfs/utils'
import { useNavigation } from '@react-navigation/native'
import { FC, useCallback, useEffect, useRef, useState } from 'react'
import { ScrollView } from 'react-native-gesture-handler'
import { useLazyApiData, useStores } from '../../data/store'
import '../../ieConfig/MobxConfig'
import { isIFrame } from '../../utils'
import { pages } from '../../utils/constants'
import { PaymentAmountHeader } from './paymentAmountHeader'
import { PaymentInstruction } from './paymentInstruction'
import { ProgressTimer } from './progressTimer'
import styles from './styles'
import { TipsInfo } from './tipsInfo'

const DELAY: number = 5000
const Progress: FC = () => {
  const navigation = useNavigation()

  const { checkPaymentStatus, paymentStatus, timeout, retUrl, txnId, theme, intentId, setHideHeaderCloseIcon } =
    useStores((root) => ({
      checkPaymentStatus: root.getPaymentStatusApi,
      paymentStatus: root.transaction.paymentStatus,
      timeout: root.transaction.retry.timeout,
      updateShowPopup: root.config.updateShowPopup,
      txnId: root.transaction.id.id,
      retUrl: root.transaction.getMerchantRedirectingUrl(),
      theme: root?.config?.merchantTheme,
      intentId: root.transaction.id.intentId,
      setHideHeaderCloseIcon: root.config.setHideHeaderCloseIcon,
    }))

  useEffect(() => {
    setHideHeaderCloseIcon(true)
  }, [setHideHeaderCloseIcon])
  const [delay, setDelay] = useState<number | null>(1000)
  const [timeLeft, setTimeLeft] = useState(Number(timeout))

  const paymentRef = useRef<any>(null)
  const [progress, setProgress] = useState(0)

  const [checkPaymentStatusApi, { state: paymentStatusState }] = useLazyApiData(checkPaymentStatus)

  const navigateStatus = useCallback(() => {
    setDelay(null)
    // navigate(pages.paymentstatus)
    navigation.reset({
      index: 0,
      routes: [{ name: pages.paymentstatus }],
    })
  }, [navigation])

  const navigateToMerchant = useCallback(() => {
    if (isIFrame()) {
      window.parent.postMessage(
        {
          txnId,
          intentId,
          status: 'completed',
          message: '',
          rUrl: retUrl,
        },
        '*',
      )
    } else {
      //Linking.openURL(retUrl)
      window.location.href = retUrl
    }
  }, [intentId, retUrl, txnId])

  // TODO: This check or switch should happen inside store. UI only know that there is a status check.
  const statusCheck = useCallback(async () => {
    checkPaymentStatusApi()
  }, [checkPaymentStatusApi])

  // TODO: This is not correct. Refeactor this.
  useEffect(() => {
    if (paymentStatusState === 'fulfilled') {
      if (paymentStatus === 'SUCCESS' || paymentStatus === 'ACCEPTED') {
        navigateToMerchant()
      } else if (paymentStatus === 'FAILED' || paymentStatus === 'failed') {
        navigateToMerchant()
      } else {
        setTimeout(() => checkPaymentStatusApi(), DELAY)
      }
    }
  }, [checkPaymentStatusApi, navigateStatus, navigateToMerchant, paymentStatus, paymentStatusState])

  useEffect(() => {
    statusCheck()
  }, [statusCheck])

  useEffect(() => {
    if (paymentRef?.current) {
      paymentRef?.current?.submit()
    }
  })

  useInterval(() => {
    setProgress(progress + 1)
    if (timeLeft >= 1) {
      setTimeLeft(timeLeft - 1)
    } else if (timeLeft === 0) {
      navigateToMerchant()
    }
  }, delay)

  return (
    <Box {...styles.containerView} backgroundColor={theme?.bodyBgColor as ColorOptions}>
      <ScrollView style={{ flexGrow: 1 }}>
        <PaymentAmountHeader />

        <ProgressTimer timeLeft={timeLeft} progress={progress} />
        <PaymentInstruction />
      </ScrollView>
      <TipsInfo />
    </Box>
  )
}

export default Progress
